import { render } from "./ForcesView.vue?vue&type=template&id=7c892ab2&scoped=true"
import script from "./ForcesView.vue?vue&type=script&lang=js"
export * from "./ForcesView.vue?vue&type=script&lang=js"

import "./ForcesView.vue?vue&type=style&index=0&id=7c892ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c892ab2"]])

export default __exports__